import { render, staticRenderFns } from "./GlobalSearchBar.vue?vue&type=template&id=6c2656ad&scoped=true&"
import script from "./GlobalSearchBar.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchBar.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalSearchBar.vue?vue&type=style&index=0&id=6c2656ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2656ad",
  null
  
)

export default component.exports